import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PrimeListBoxControl } from '../../../form-models/prime-listbox-control';

@Component({
  selector: 'hb-dynamic-prime-list-box',
  templateUrl: './dynamic-prime-list-box.component.html',
  styleUrls: ['./dynamic-prime-list-box.component.scss'],
})
export class DynamicPrimeListBoxComponent {
  @Input() control: PrimeListBoxControl;
  @Input() formGroup: FormGroup;
  @Output() clickEvent = new EventEmitter(null);

  constructor() {}

  onClickEvent() {
    this.clickEvent.emit();
  }

  showButton(): boolean {
    return !this.control.disabled;
  }
}
